import AccountEntry from '@/generated/classes/AccountEntry';

export default class AccountEntryExtend extends AccountEntry {
  constructor() {
    super();
  }
}
